export class SalaryClass {
    id?: number;
    basicSalary?: number;
    upperSalary?: number;
    currency?: string;
    period?: string;
    additionalInfo?: string;
}
